import React from 'react';
import { Property } from '@/types/index';

interface PropertySummaryProps {
  property: Property;
}

const fmt = (v?: number) =>
  v != null
    ? new Intl.NumberFormat('fr-CH', { maximumFractionDigits: 0 }).format(v)
    : '—';

export const PropertySummary: React.FC<PropertySummaryProps> = ({ property }) => {
  const items = [
    { icon: '💰', label: 'Prix de vente', value: property.askingPrice ? `${fmt(property.askingPrice)} CHF` : '—' },
    { icon: '📐', label: 'Surface', value: `${property.area} m²` },
    { icon: '📊', label: 'Prix/m²', value: property.askingPrice && property.area ? `${fmt(property.askingPrice / property.area)} CHF/m²` : '—' },
    { icon: '🏠', label: 'Pièces', value: `${property.rooms}` },
    { icon: '📍', label: 'Adresse', value: `${property.address}, ${property.postalCode} ${property.city}` },
    { icon: '🏢', label: 'Type', value: property.affectation },
    { icon: '📅', label: 'Année', value: property.buildingYear ? `${property.buildingYear}` : '—' },
    { icon: '💳', label: 'Charges PPE', value: property.ppeCharges ? `${fmt(property.ppeCharges)} CHF/mois` : '—' },
    { icon: '🏗️', label: 'Étage', value: property.floor || '—' },
    { icon: '🛗', label: 'Ascenseur', value: property.hasElevator ? 'Oui' : 'Non' },
    { icon: '🔑', label: 'Cave', value: property.hasCellar ? 'Oui' : 'Non' },
  ];

  return (
    <div className="bg-gray-100 dark:bg-gray-800 rounded-xl p-4">
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {items.map((item, i) => (
          <div key={i} className="relative group flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 cursor-default">
            <span>{item.icon}</span>
            <span className="font-medium text-gray-800 dark:text-gray-200">{item.value}</span>
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 dark:bg-gray-700 rounded-lg shadow-lg whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 pointer-events-none">
              {item.label}
              <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800 dark:border-t-gray-700" />
            </span>
            {i < items.length - 1 && (
              <span className="text-gray-300 dark:text-gray-600 ml-2">|</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
